import { useEffect, useState } from "react";
import { CasProfileApi } from "@jti/rest-api";
const useUser = (ageVerificationCheck = false) => {
    const [isLoggedIn, setLogged] = useState(null);
    const [isUserVerificationPending, setUserVerificationPending] = useState(true);
    const [user, setUser] = useState(null);
    const [hasAV, setHasAV] = useState(false);
    useEffect(() => {
        const savedUser = window.localStorage.getItem("user");
        if (savedUser) {
            try {
                const user = JSON.parse(savedUser);
                setUser(user);
                setLogged(user !== null);
                if (ageVerificationCheck) {
                    CasProfileApi.init()
                        .getProfile()
                        .then((userProfile) => {
                        setHasAV(userProfile.is_age_verified);
                        setUserVerificationPending(false);
                    })
                        .catch(() => {
                        setUser(null);
                    });
                }
            }
            catch (error) {
                console.error("Cannot parse user data saved in storage");
            }
        }
        else {
            setLogged(false);
        }
    }, [ageVerificationCheck]);
    return {
        isLoggedIn,
        hasAV,
        uuid: user?.uuid ?? null,
        isUserVerificationPending,
        userData: user,
    };
};
export default useUser;
//# sourceMappingURL=useUser.js.map